/**
 * /tenants/$slug/access-governance/approval-policies — the multi-stage / posture
 * approval-policy editor (P-B engine).
 *
 * Shim route, sibling of the queue / approvers / routing-rules tabs. The
 * access_governance.read (view) and access_governance.manage + step-up (save) gates are enforced
 * backend-side; the SPA mounts the page and the endpoints surface the right errors.
 */

import { createFileRoute } from "@tanstack/react-router";
import { AccessGovernanceApprovalPoliciesPage } from "@/features/approval-policies/pages/approval-policies-page";

export const Route = createFileRoute(
  "/_authed/tenants/$slug/access-governance/approval-policies",
)({
  component: AccessGovernanceApprovalPoliciesPage,
});
